/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Model from 'flarum/common/Model';
import type Discussion from 'flarum/common/models/Discussion';
import type Article from 'flarum/orell-articles/models/Article';

/**
 * Prototype methods, not class fields: a field shadows the prototype and would swallow any
 * `Extend.Model` aimed at this model.
 */
export default class Review extends Model {
	rating() {
		return Model.attribute<number>('rating').call(this);
	}

	article() {
		return Model.hasOne<Article>('article').call(this);
	}

	discussion() {
		return Model.hasOne<Discussion>('discussion').call(this);
	}

	isSimple() {
		return Model.attribute<boolean>('isSimple').call(this);
	}

	exported() {
		return Model.attribute<boolean>('exported').call(this);
	}

	shopReviewsLocked() {
		return Model.attribute<boolean>('shopReviewsLocked').call(this);
	}

	exportSyncFailed() {
		return Model.attribute<boolean>('exportSyncFailed').call(this);
	}

	cannotExportUnapproved() {
		return Model.attribute<boolean>('cannotExportUnapproved').call(this);
	}

	shouldSync(): boolean {
		const article = this.article();

		if (!this.isSimple() && this.exported() && !this.shopReviewsLocked() && article && article.isAvailable()) {
			return true;
		}

		return false;
	}
}
